import PushOrg from "@onestore/hel/dist/components/organisms/PushOrg"
import { connect, mapProps } from "@formily/react"
import MarkdownTitle from "@gatsby-plugin-generic-page/components/Markdown/Title"

export interface TextProps {
  content: string
}

const TextLayout = ({ content }: TextProps) => (
  <PushOrg bottomSpace={2}>
    <MarkdownTitle typography="tiny1">{content}</MarkdownTitle>
  </PushOrg>
)

const Text = connect(
  TextLayout,
  mapProps({}, (props: TextProps) => {
    return {
      content: props.content,
    }
  })
)

export default Text
